import React, { Component } from "react";
import { s360ConfigService } from "../../Services/S360Config";
import HWLog from "../../HWLibrary/HWLog";
import dayjs from "dayjs";
import Select from "react-select";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
class MessageA13 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.entry.text_data.data[0].value,
      actionDone: false,
    };
  }

  onMouseEnterButton = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color = isNullOrUndefined(
      designDetails.buttonHighlightTextColor
    )
      ? "#f8f5f5"
      : designDetails.buttonHighlightTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonHighlightBackgroundColor
    )
      ? "#2935dd"
      : designDetails.buttonHighlightBackgroundColor;
  };

  onMouseLeaveButton = (e) => {
    if (!e.target) {
      return;
    }
    // if (e.target.disabled === true) { return }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color = isNullOrUndefined(designDetails.buttonTextColor)
      ? "#0092ed"
      : designDetails.buttonTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonBackgroundColor
    )
      ? "#fff"
      : designDetails.buttonBackgroundColor;
  };

  onListItemSelect = (item) => {
    if (this.state.actionDone) {
      this.setState({ value: false });
    } else {
      this.setState({ value: item.target.value });
    }
    //this.props.actions.sendMessage(item.value);
  };

  onSubmit = (e) => {
    this.onMouseLeaveButton(e);
    this.setState({ value: false, actionDone: true });
    this.props.actions.sendMessage(this.state.value);
    var n = document.getElementsByClassName(
      "s360-message-box-custom-a15-received"
    );
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
      // this.onMouseLeave({ "target": n[i]});
    }
  };

  parseListValues = () => {
    try {
      return this.props.entry.text_data.data || [];
    } catch (error) {
      HWLog.warn("Invalid List Data for Custom Type A13:");
    }
    return [];
  };

  messageBoxStyle = () => {
    return {
      background: s360ConfigService.config.designDetails.senderMessageColor,
      fontFamily: s360ConfigService.config.designDetails.SenderMessageFont,
      fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize,
      color: s360ConfigService.config.designDetails.senderMessageFontColor,
    };
  };

  messageTimeClassName = () => {
    return "s360-message-time-received";
  };

  messageTimeStyle = () => {
    return {
      fontFamily: s360ConfigService.config.designDetails.messageFont,
      fontSize: s360ConfigService.config.designDetails.messageTimeFontSize,
      color: s360ConfigService.config.designDetails.messageTimeFontColor,
    };
  };

  messageBoxSubmitStyle = () => {
    const designDetials = s360ConfigService.config.designDetails;
    let styleData = {
      // background: s360ConfigService.config.designDetails.recieverMessageColor,
      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
      // color: s360ConfigService.config.designDetails.recieverMessageFontColor,
      marginLeft: "15px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: isNullOrUndefined(designDetials.buttonBorderColor)
        ? "#0092ed"
        : designDetials.buttonBorderColor,

      borderRadius: isNullOrUndefined(designDetials.buttonBorderRadius)
        ? 20
        : designDetials.buttonBorderRadius,
      color: isNullOrUndefined(designDetials.buttonTextColor)
        ? "#0092ed"
        : designDetials.buttonTextColor,
      backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor)
        ? "#fff"
        : designDetials.buttonBackgroundColor,
      fontWeight: isNullOrUndefined(designDetials.senderFontWeight) ? 500 : 500,
    };
    return styleData;
    // return {
    //     background: s360ConfigService.config.designDetails.recieverMessageColor,
    //      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
    //      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
    //      color: s360ConfigService.config.designDetails.recieverMessageFontColor,
    //      marginLeft: '15px'
    //     }
  };

  selectOptionsStyle = {
    control: (provided, state) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
      borderRadius: "0px",
      color: s360ConfigService.config.designDetails.headerColor,
      width: "100% !important",
      "&:hover": {
        border: "none",
      },
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: s360ConfigService.config.designDetails.dropDownFontColor,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = s360ConfigService.config.designDetails.dropDownFontColor;
      return {
        ...styles,
        fontFamily: isNullOrUndefined(
          s360ConfigService.config.designDetails.dropDownFontFamily
        )
          ? "sans-serif"
          : s360ConfigService.config.designDetails.dropDownFontFamily,
        fontWeight: isNullOrUndefined(
          s360ConfigService.config.designDetails.dropDownFontWeight
        )
          ? 500
          : s360ConfigService.config.designDetails.dropDownFontWeight,
        fontSize: isNullOrUndefined(
          s360ConfigService.config.designDetails.dropDownFontSize
        )
          ? "12px"
          : s360ConfigService.config.designDetails.dropDownFontSize,
        color: isNullOrUndefined(
          s360ConfigService.config.designDetails.dropDownFontColor
        )
          ? "black"
          : s360ConfigService.config.designDetails.dropDownFontColor,
        backgroundColor: isDisabled ? null : isSelected ? color : null,
        color: isSelected ? "white" : color,
        ":active": {
          ...styles[":active"],
          backgroundColor: null,
        },
        borderBottom: "1px solid #ccc",
      };
    },
  };
  render() {
    let optionsArray = this.parseListValues().map((item) => {
      return { value: item.value, label: item.name };
    });
    // console.log(this.props.entry.text_data.data,"A13 DATA")
    return (
      <div
        aria-disabled={!this.state.value}
        className="s360-message-cotainer-custom-a13-received"
      >
        <div
          className="s360-message-box-custom-a13-received"
          style={this.messageBoxStyle()}
        >
          <select
            onChange={(e) => this.onListItemSelect(e)}
            styles={this.selectOptionsStyle}
          >
            {optionsArray.map((oneoption) => (
              <option>{oneoption.value}</option>
            ))}
          </select>
        </div>
        {this.props.isLastEntry && this.props.sentTimestamp && (
          <div
            className={this.messageTimeClassName()}
            style={this.messageTimeStyle()}
          >
            {dayjs.unix(this.props.sentTimestamp).format("DD MMM h:mm a")}
          </div>
        )}
        <div className="s360-message-cotainer-received">
          <button
            disabled={this.props.disabled}
            className="s360-message-box-custom-a15-received"
            onClick={this.onSubmit}
            onMouseEnter={this.onMouseEnterButton}
            onMouseLeave={this.onMouseLeaveButton}
            style={this.messageBoxSubmitStyle()}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }
}

export default MessageA13;
